import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const EmissionFactorsIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        d="M5 4a1 1 0 0 0-1 1v14c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1H5ZM2 5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5Z"
        clipRule="evenodd"
      />
      <path
        d="M13.3 8.3c-.3.3-.5.8-.5 1.7v4.2c0 1-.2 2-1 2.8-.6.7-1.6 1-2.8 1a1 1 0 1 1 0-2c.8 0 1.2-.2 1.4-.4.2-.2.4-.6.4-1.4V10c0-1.1.3-2.3 1-3 .9-.9 2-1.2 3.3-1a1 1 0 1 1-.2 2c-1-.1-1.4 0-1.6.3Z"
        clipRule="evenodd"
      />
      <path
        d="M8 11.2c0-.6.4-1 1-1h5.7a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default EmissionFactorsIcon;
